import { render } from "./TeacherResources.vue?vue&type=template&id=bc4462e0&scoped=true"
import script from "./TeacherResources.vue?vue&type=script&lang=js"
export * from "./TeacherResources.vue?vue&type=script&lang=js"

import "./TeacherResources.vue?vue&type=style&index=0&id=bc4462e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc4462e0"]])

export default __exports__